
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-writing",
      function () {
        return require("private-next-pages/my-writing/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-writing"])
      });
    }
  